import { MapOptions } from 'google-map-react';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || '';
const RIYADH = { lat: 24.72, lng: 46.61 };
const SAUDI_ARABIA_BOUNDS = {
  north: 34,
  south: 13,
  west: 34,
  east: 56,
};

const MAP_OPTIONS: MapOptions & {
  draggableCursor: string;
  draggingCursor: string;
} = {
  draggableCursor: 'grab',
  draggingCursor: 'grabbing',
};

export const GOOGLE_MAP_DEFAULT_CONFIG = {
  SAUDI_ARABIA_BOUNDS,
  RIYADH,
  DEFAULT_ZOOM: 5,
  BOOT_STRAP_URL_KEYS: { key: GOOGLE_MAPS_API_KEY, libraries: ['places', 'marker'] },
  DEFAULT_CENTER: RIYADH,
  DEFAULT_EXPANSION_ZOOM: 2,
  MAP_OPTIONS,
};

export enum CONTROL_POSITION {
  TOP_LEFT = 1,
  TOP_CENTER = 2,
  TOP = 2,
  TOP_RIGHT = 3,
  LEFT_CENTER = 4,
  LEFT_TOP = 5,
  LEFT = 5,
  LEFT_BOTTOM = 6,
  RIGHT_TOP = 7,
  RIGHT = 7,
  RIGHT_CENTER = 8,
  RIGHT_BOTTOM = 9,
  BOTTOM_LEFT = 10,
  BOTTOM_CENTER = 11,
  BOTTOM = 11,
  BOTTOM_RIGHT = 12,
  CENTER = 13,
}
